import { render, staticRenderFns } from "./DeleteCustomInvestorGoalDistributeBalance.vue?vue&type=template&id=777cc9ab&"
import script from "./DeleteCustomInvestorGoalDistributeBalance.vue?vue&type=script&lang=ts&"
export * from "./DeleteCustomInvestorGoalDistributeBalance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
